import { render, staticRenderFns } from "./orderType.vue?vue&type=template&id=c1f25b20"
import script from "./orderType.vue?vue&type=script&lang=js"
export * from "./orderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports